import { isNil } from 'lodash';
import * as orderFileService from 'services/orderFileService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWRFilesData = Awaited<ReturnType<typeof orderFileService.getOrderFilesAsync>>;

const useOrderFiles = (
  orderId: number,
  load = true
): SWRResponse<SWRFilesData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_ORDER_FILES_ENDPOINT, orderId] : null,
    async ([_, params]) => await orderFileService.getOrderFilesAsync(params)
  );

export const SWR_ORDER_FILES_ENDPOINT = 'orders-files';

export default useOrderFiles;
